module.exports = __webpack_public_path__ + "img/img100.f3760046.svg";